import { call, put, takeLatest } from 'redux-saga/effects';
import { base_url, endpoints } from '../../../constants';
import { AxiosService } from '../../../services';
import { actionTypes } from '../../../types';
import {
    downloadReferenceVideoSuccess,
    downloadReferenceVideoFailure
} from '../../actions/CreateCampaignActions/downloadReferenceVideoActions';

function* downloadReferenceVideoWorker({ payload, callback }) {
    try {
        const response = yield call(AxiosService, {
            method: 'get',
            base_url: base_url,
            endPoint: `${endpoints.downloadReferenceVideo}?campaignId=${payload.campaignId}`,
            isAuth: true,
        });

        yield put(
            downloadReferenceVideoSuccess({
                status: response?.data?.status,
                response: response?.data?.response,
                message: response?.data?.message,
            })
        );

        if (callback) {
            callback(
                response?.data?.status,
                response?.data?.response,
                response?.data?.message
            );
        }
    } catch (error) {
        yield put(
            downloadReferenceVideoFailure({
                status: error?.response?.data?.status,
                response: {},
                message: error?.response?.data?.message,
            })
        );
        if (callback) {
            callback(error?.response?.data?.status || 500, null, error?.response?.data?.message || 'Download failed');
        }
    }
}

function* downloadReferenceVideoSaga() {
    yield takeLatest(actionTypes.DOWNLOAD_REFERENCE_VIDEO_REQUEST, downloadReferenceVideoWorker);
}

export default downloadReferenceVideoSaga;
